import script from "./OrderItem.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderItem.vue?vue&type=script&setup=true&lang=js"

import "./OrderItem.vue?vue&type=style&index=0&id=59ef2a58&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59ef2a58"]])

export default __exports__